import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../../declarations/redux';

export const useAppDispatch: () => AppDispatch = useDispatch;
